<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <div class="topBox flex">
      <div class="topLeft flex" style="align-items: center; flex-wrap: wrap">
        <template v-if="isOfficialConsignList">
          <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
            <span style="white-space: nowrap; margin-right: 8px">商品编号：</span>
            <div style="width: 132px">
              <el-input v-model="query.productNo" placeholder="模糊查询" clearable @keyup.enter.native="searchFn" />
            </div>
          </div>

          <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
            <span style="white-space: nowrap; margin-right: 8px">代号：</span>
            <div style="width: 100px">
              <el-input v-model="query.importCode" placeholder="模糊查询" clearable @keyup.enter.native="searchFn" />
            </div>
          </div>
        </template>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">状态：</span>
          <div style="width: 180px">
            <el-select v-model="query.status" placeholder="全部" clearable @change="searchFn">
              <el-option v-for="item in statusOptions" :key="String(item.value)" :label="item.label" :value="item.value" />
            </el-select>
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">订单号：</span>
          <div style="width: 220px">
            <el-input v-model="query.orderNo" placeholder="模糊查询" clearable @keyup.enter.native="searchFn" />
          </div>
        </div>

        <div
          v-if="isOfficialConsignList"
          class="flex"
          style="align-items: center; margin-right: 12px; margin-bottom: 4px"
        >
          <span style="white-space: nowrap; margin-right: 8px">闲鱼单号：</span>
          <div style="width: 200px">
            <el-input
              v-model="query.goofishOrderNo"
              placeholder="模糊查询"
              clearable
              @keyup.enter.native="searchFn"
            />
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">买家昵称：</span>
          <div style="width: 130px">
            <el-input v-model="query.buyerNickName" placeholder="可选" clearable @keyup.enter.native="searchFn" />
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">{{ isOfficialConsignList ? "寄售用户" : "卖家昵称" }}：</span>
          <div :style="{ width: isOfficialConsignList ? '148px' : '130px' }">
            <el-input
              v-if="isOfficialConsignList"
              v-model="query.consignorKeyword"
              placeholder="昵称/会员号/姓名"
              clearable
              @keyup.enter.native="searchFn"
            />
            <el-input
              v-else
              v-model="query.sellerNickName"
              placeholder="可选"
              clearable
              @keyup.enter.native="searchFn"
            />
          </div>
        </div>

        <el-button type="success" size="small" @click="searchFn">搜索</el-button>
        <el-button size="small" @click="resetFn">重置</el-button>
      </div>
    </div>

    <el-tabs v-model="activeStatusTab" type="card" class="secondhand-order-tabs" @tab-click="handleStatusTabClick">
      <el-tab-pane v-for="t in statusTabs" :key="t.name" :label="t.label" :name="t.name" />
    </el-tabs>

    <div class="table-scroll-wrap">
    <el-table
      class="secondhand-order-table"
      :data="tableData"
      border
      style="width: 100%; margin-top: 12px"
      v-loading="loading"
    >
      <el-table-column prop="orderNo" label="订单号" min-width="180" align="center" />
      <el-table-column
        v-if="isOfficialConsignList"
        label="成交渠道"
        width="170"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag v-if="isGoofishChannel(scope.row)" type="warning" size="mini">
            {{ scope.row.saleChannel === "GOOFISH_AUCTION" ? "闲鱼拍卖" : "闲鱼" }}
          </el-tag>
          <el-tag v-else type="success" size="mini">自研</el-tag>
          <div
            v-if="isGoofishChannel(scope.row) && resolveGoofishOrderNo(scope.row)"
            style="margin-top: 4px; color: #666; font-size: 12px; line-height: 1.3"
          >
            {{ resolveGoofishOrderNo(scope.row) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="isOfficialConsignList" label="商品编号" width="160" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ resolveProductNo(scope.row) || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isOfficialConsignList" label="代号" width="90" align="center">
        <template slot-scope="scope">
          <span>{{ resolveImportCode(scope.row) || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="productTitle" label="商品标题" min-width="220" class-name="cell-title-wrap" />
      <el-table-column label="支付金额(元)" width="120" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.totalAmount) }}</template>
      </el-table-column>
      <el-table-column label="商品价格(元)" width="120" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.price) }}</template>
      </el-table-column>
      <el-table-column label="运费(元)" width="110" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.freight) }}</template>
      </el-table-column>
      <el-table-column label="支付时间" width="170" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.payTime) }}</template>
      </el-table-column>
      <el-table-column label="买家" width="140" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ displayText(scope.row.buyerNickName) || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="!isOfficialConsignList" prop="sellerNickName" label="卖家" width="140" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ displayText(scope.row.sellerNickName) || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column v-else label="寄售用户" min-width="140" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ displayConsignorNick(scope.row) || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="170" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
      </el-table-column>
      <el-table-column label="状态" width="140" align="center" fixed="right">
        <template slot-scope="scope">
          <span :style="{ color: statusColor(scope.row.status) }">{{ statusLabel(scope.row.status, scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="收货地址" width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="isBuyerAddressMissing(scope.row)" type="danger" size="mini">缺失</el-tag>
          <el-tag v-else-if="Number(scope.row.deliveryType) !== 2" type="success" size="mini">已填</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="160" width="160" align="center" fixed="right" class-name="order-op-cell">
        <template slot-scope="scope">
          <div class="order-op-actions">
            <el-button size="small" @click="detailFn(scope.row)">详情</el-button>
            <el-button
              v-if="canSupplementBuyerAddress(scope.row)"
              type="warning"
              plain
              size="small"
              @click="openSupplementBuyerAddressFromRow(scope.row)"
            >补写地址</el-button>
            <el-button
              v-if="canReverseRefund(scope.row)"
              type="danger"
              plain
              size="small"
              @click="openReverseRefundDialog(scope.row)"
            >未分账退款</el-button>
            <el-button
              v-if="canDivRefund(scope.row)"
              type="warning"
              plain
              size="small"
              @click="openDivRefundDialog(scope.row)"
            >已分账退款</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <list-pagination
      :total="tableTotal"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      @page-change="changePage"
      @size-change="handlePageSizeChange"
    />

    <el-dialog title="订单详情" :visible.sync="detailVisible" width="920px" custom-class="secondhand-order-detail-dialog">
      <div v-if="detail" class="detail-dialog-body">
        <section class="detail-section detail-section--product">
          <div class="detail-product-card">
            <div class="detail-product-card__meta">
              <div class="detail-product-card__title">{{ detail.productTitle || "—" }}</div>
            </div>
          </div>
          <h4 class="detail-section__title detail-section__title--images">商品图片</h4>
          <div v-if="detailProductImageUrls.length" class="detail-dialog-images">
            <el-image
              v-for="(url, idx) in detailProductImageUrls"
              :key="idx"
              class="detail-dialog-img"
              :src="url"
              fit="cover"
              :preview-src-list="detailProductImageUrls"
              :initial-index="idx"
            />
          </div>
          <span v-else class="detail-dialog-images-empty">暂无图片</span>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">订单信息</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">订单号</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ detail.orderNo || "-" }}</span>
                <el-button v-if="detail.orderNo" class="detail-copy-btn" type="text" @click="copyText(detail.orderNo)">复制</el-button>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">状态</div>
              <div class="detail-field-value">
                <el-tag size="mini" :type="statusTagType(detail.status)">{{ statusLabel(detail.status, detail) }}</el-tag>
                <span v-if="detail.useInspection === 1" style="margin-left: 8px">
                  <el-tag size="mini" type="info">安心购</el-tag>
                </span>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">支付金额(元)</div>
              <div class="detail-field-value">
                <span class="detail-money detail-money--primary">{{ formatMoney(detail.totalAmount) }}</span>
                <span style="margin-left: 10px">
                  <el-tag size="mini" :type="detail.isPay === 1 ? 'success' : 'warning'">{{ detail.isPay === 1 ? "已支付" : "未支付" }}</el-tag>
                </span>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">商品价格(元)</div>
              <div class="detail-field-value">
                <span class="detail-money">{{ formatMoney(detail.price) }}</span>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">运费(元)</div>
              <div class="detail-field-value">
                <span class="detail-money">{{ formatMoney(detail.freight) }}</span>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">保证金(元)</div>
              <div class="detail-field-value">
                <span class="detail-money">{{ detail.deposit == null ? "-" : formatMoney(detail.deposit) }}</span>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">支付时间</div>
              <div class="detail-field-value">{{ formatTime(detail.payTime) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">支付截止</div>
              <div class="detail-field-value">{{ formatTime(detail.payExpireTime) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">创建时间</div>
              <div class="detail-field-value">{{ formatTime(detail.createTime) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">确认收货时间</div>
              <div class="detail-field-value">{{ formatTime(detail.confirmTime) }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">更新时间</div>
              <div class="detail-field-value">{{ formatTime(detail.updateTime) }}</div>
            </div>
            <div class="detail-field-cell detail-field-cell--full" v-if="detail.systemCloseType || detail.systemCloseReason">
              <div class="detail-field-label">系统关单</div>
              <div class="detail-field-value detail-field-value--multiline">
                <template v-if="detail.systemCloseType">
                  <el-tag size="mini" type="info">{{ systemCloseTypeLabel(detail.systemCloseType) }}</el-tag>
                  <span v-if="detail.systemCloseReason" style="margin-left: 8px">{{ detail.systemCloseReason }}</span>
                </template>
                <template v-else>{{ detail.systemCloseReason }}</template>
              </div>
            </div>
            <div class="detail-field-cell detail-field-cell--full" v-if="detail.sellerCancelReason">
              <div class="detail-field-label">卖家取消原因</div>
              <div class="detail-field-value">{{ detail.sellerCancelReason }}</div>
            </div>
            <div class="detail-field-cell detail-field-cell--full" v-if="detail.remark">
              <div class="detail-field-label">备注</div>
              <div class="detail-field-value detail-field-value--multiline">{{ detail.remark }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">支付信息</h4>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">微信交易单号</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ detail.transactionId || "-" }}</span>
                <el-button
                  v-if="detail.transactionId"
                  class="detail-copy-btn"
                  type="text"
                  @click="copyText(detail.transactionId)"
                >复制</el-button>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">交易单订单号</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ detail.combineOutTradeNo || "-" }}</span>
                <el-button
                  v-if="detail.combineOutTradeNo"
                  class="detail-copy-btn"
                  type="text"
                  @click="copyText(detail.combineOutTradeNo)"
                >复制</el-button>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">预支付ID</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ detail.prepayId || "-" }}</span>
                <el-button
                  v-if="detail.prepayId"
                  class="detail-copy-btn"
                  type="text"
                  @click="copyText(detail.prepayId)"
                >复制</el-button>
              </div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">买家信息</h4>
          <div class="detail-field-box detail-field-box--cols2 detail-field-box--compact">
            <div class="detail-field-cell">
              <div class="detail-field-label">昵称</div>
              <div class="detail-field-value">{{ displayText(detail.buyerNickName) || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">用户ID</div>
              <div class="detail-field-value">{{ detail.buyerUserId || "-" }}</div>
            </div>
          </div>
        </section>

        <section v-if="isOfficialConsignList && detailProduct" class="detail-section">
          <h4 class="detail-section__title">货主信息</h4>
          <div class="detail-field-box detail-field-box--cols2 detail-field-box--compact">
            <div class="detail-field-cell">
              <div class="detail-field-label">昵称</div>
              <div class="detail-field-value">{{ displayConsignorNick(detail) || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">会员号</div>
              <div class="detail-field-value">{{ detailProduct.consignorScentId || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">实名</div>
              <div class="detail-field-value">{{ detailProduct.consignorRealName || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">用户ID</div>
              <div class="detail-field-value">{{ detailProduct.consignorUserId || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">商品编号</div>
              <div class="detail-field-value">{{ resolveProductNo(detail) || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">代号</div>
              <div class="detail-field-value">{{ resolveImportCode(detail) || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">关联寄售订单号</div>
              <div class="detail-field-value">
                <span v-if="detailProduct.sourceConsignOrderNo" class="detail-text-success">{{ detailProduct.sourceConsignOrderNo }}</span>
                <span v-else class="detail-text-danger">未关联</span>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">货架号</div>
              <div class="detail-field-value">{{ detailProduct.sourceConsignShelfNo || "-" }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <div class="detail-section__title-row">
            <h4 class="detail-section__title">买家收货地址</h4>
            <el-button
              v-if="canSupplementBuyerAddress(detail)"
              type="warning"
              plain
              size="mini"
              @click="openSupplementBuyerAddressDialog"
            >补写收货地址</el-button>
          </div>
          <el-alert
            v-if="isBuyerAddressMissing(detail) && canSupplementBuyerAddress(detail)"
            :title="isOfficialConsignList
              ? '该订单缺少买家收货地址，平台无法发货。请点击「补写收货地址」填写后保存。'
              : '该订单缺少买家收货地址，卖家无法发货。请点击「补写收货地址」填写后保存。'"
            type="error"
            :closable="false"
            show-icon
            style="margin-bottom: 12px"
          />
          <el-alert
            v-else-if="isBuyerAddressMissing(detail) && !canSupplementBuyerAddress(detail)"
            title="该订单缺少收货地址，但当前订单状态已不可后台补写（可能已发货/已关闭/为自提单）。"
            type="warning"
            :closable="false"
            show-icon
            style="margin-bottom: 12px"
          />
          <div class="detail-field-box detail-field-box--cols2 detail-field-box--compact">
            <div class="detail-field-cell">
              <div class="detail-field-label">收货人</div>
              <div class="detail-field-value">{{ buyerAddrSnap(detail).name || displayText(detail.buyerName) || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">联系电话</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ buyerAddrSnap(detail).phone || detail.buyerPhone || "-" }}</span>
                <el-button
                  v-if="buyerAddrSnap(detail).phone || detail.buyerPhone"
                  class="detail-copy-btn"
                  type="text"
                  @click="copyText(buyerAddrSnap(detail).phone || detail.buyerPhone)"
                >复制</el-button>
              </div>
            </div>
            <div class="detail-field-cell detail-field-cell--full">
              <div class="detail-field-label">省市区</div>
              <div class="detail-field-value">{{ buyerAddrSnap(detail).region || "-" }}</div>
            </div>
            <div class="detail-field-cell detail-field-cell--full">
              <div class="detail-field-label">详细地址</div>
              <div class="detail-field-value detail-field-value--multiline">{{ buyerAddrDetailLine(detail) }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">{{ isOfficialConsignList ? "平台发货地址" : "卖家发货地址" }}</h4>
          <p v-if="isOfficialConsignList" class="detail-section__hint">官方寄售由平台代发，以下为平台寄件信息。</p>
          <div class="detail-field-box detail-field-box--cols2 detail-field-box--compact">
            <div class="detail-field-cell">
              <div class="detail-field-label">寄件人</div>
              <div class="detail-field-value">{{ sellerAddrSnap(detail).name || displayText(detail.sellerName) || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">联系电话</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ sellerAddrSnap(detail).phone || detail.sellerPhone || "-" }}</span>
                <el-button
                  v-if="sellerAddrSnap(detail).phone || detail.sellerPhone"
                  class="detail-copy-btn"
                  type="text"
                  @click="copyText(sellerAddrSnap(detail).phone || detail.sellerPhone)"
                >复制</el-button>
              </div>
            </div>
            <div class="detail-field-cell detail-field-cell--full">
              <div class="detail-field-label">省市区</div>
              <div class="detail-field-value">{{ sellerAddrSnap(detail).region || "-" }}</div>
            </div>
            <div class="detail-field-cell detail-field-cell--full">
              <div class="detail-field-label">详细地址</div>
              <div class="detail-field-value detail-field-value--multiline">{{ sellerAddrDetailLine(detail) }}</div>
            </div>
          </div>
        </section>

        <section class="detail-section">
          <h4 class="detail-section__title">
            {{ isOfficialConsignList ? "发货物流（平台 → 买家）" : "发货物流（卖家 → 买家）" }}
          </h4>
          <p v-if="isOfficialConsignList" class="detail-section__hint">平台寄出给买家后的物流；无单号表示尚未发货或未回写。</p>
          <div class="detail-field-box">
            <div class="detail-field-cell">
              <div class="detail-field-label">物流公司</div>
              <div class="detail-field-value">{{ logisticsCompanyLabel(detail.logisticsCompany) || "-" }}</div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">物流单号</div>
              <div class="detail-field-value">
                <span class="detail-field-mono">{{ detail.logisticsNo || "-" }}</span>
                <el-button v-if="detail.logisticsNo" class="detail-copy-btn" type="text" @click="copyText(detail.logisticsNo)">复制</el-button>
                <el-button
                  v-if="isOfficialConsignList"
                  class="detail-copy-btn"
                  type="text"
                  @click="openEditLogisticsDialog"
                >{{ detail.logisticsNo ? "修改" : "填写" }}</el-button>
              </div>
            </div>
            <div class="detail-field-cell">
              <div class="detail-field-label">发货时间</div>
              <div class="detail-field-value">{{ formatTime(detail.shipTime) }}</div>
            </div>
          </div>
        </section>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="detail && canSupplementBuyerAddress(detail)"
          type="warning"
          @click="openSupplementBuyerAddressDialog"
        >补写收货地址</el-button>
        <el-button
          v-if="detail && isOfficialConsignList"
          type="primary"
          @click="openEditLogisticsDialog"
        >编辑物流单号</el-button>
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="编辑发货物流"
      :visible.sync="editLogisticsVisible"
      width="520px"
      :close-on-click-modal="false"
      @closed="resetEditLogisticsForm"
    >
      <el-form label-width="100px">
        <el-form-item label="订单号">
          <el-input :value="(detail && detail.orderNo) || '-'" disabled />
        </el-form-item>
        <el-form-item label="物流公司" required>
          <el-select
            v-model="editLogisticsForm.logisticsCompany"
            filterable
            allow-create
            default-first-option
            clearable
            placeholder="请选择或输入物流公司"
            style="width: 100%"
          >
            <el-option
              v-for="item in companyData"
              :key="item.code"
              :label="item.title"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号" required>
          <el-input
            v-model.trim="editLogisticsForm.logisticsNo"
            placeholder="请输入物流单号"
            maxlength="60"
            clearable
          />
        </el-form-item>
        <p class="detail-section__hint" style="margin: 0 0 0 100px">
          待发货订单填写完整物流后将自动变为待收货；已发货订单仅更正单号。
        </p>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editLogisticsVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLogisticsSubmitLoading" @click="submitEditLogistics">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="补写买家收货地址"
      :visible.sync="supplementAddrVisible"
      width="560px"
      :close-on-click-modal="false"
      @closed="resetSupplementAddrForm"
    >
      <el-form ref="supplementAddrFormRef" :model="supplementAddrForm" label-width="100px">
        <el-form-item label="订单号">
          <el-input :value="(detail && detail.orderNo) || '-'" disabled />
        </el-form-item>
        <el-form-item label="收货人" required>
          <el-input v-model.trim="supplementAddrForm.buyerName" placeholder="姓名" maxlength="50" />
        </el-form-item>
        <el-form-item label="联系电话" required>
          <el-input v-model.trim="supplementAddrForm.buyerPhone" placeholder="手机号" maxlength="20" />
        </el-form-item>
        <el-form-item label="省市区" required>
          <el-input v-model.trim="supplementAddrForm.areaStr" placeholder="如：广东省深圳市南山区" maxlength="120" />
        </el-form-item>
        <el-form-item label="详细地址" required>
          <el-input
            v-model.trim="supplementAddrForm.detail"
            type="textarea"
            :rows="3"
            placeholder="街道、门牌号等"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="supplementAddrVisible = false">取消</el-button>
        <el-button type="primary" :loading="supplementAddrSubmitLoading" @click="submitSupplementBuyerAddress">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑订单" :visible.sync="editVisible" width="760px" custom-class="secondhand-order-edit-dialog">
      <div v-loading="editLoading">
        <el-form v-if="editForm" ref="editFormRef" :model="editForm" label-width="120px">
          <el-form-item label="订单号">
            <el-input v-model="editForm.orderNo" disabled />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="editForm.status" placeholder="请选择" style="width: 100%">
              <el-option v-for="s in statusOptions" :key="String(s.value)" :label="s.label" :value="s.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="物流公司">
            <el-input v-model="editForm.logisticsCompany" placeholder="例如：顺丰 / 圆通" />
          </el-form-item>
          <el-form-item label="物流单号">
            <el-input v-model="editForm.logisticsNo" placeholder="请输入物流单号" />
          </el-form-item>
          <el-form-item label="发货时间">
            <el-date-picker v-model="editForm.shipTime" type="datetime" placeholder="选择发货时间" style="width: 100%" />
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="editForm.remark" type="textarea" :rows="3" placeholder="可选" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="editSubmitLoading" @click="submitEditFn">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="汇付未分账退款（支付撤销）"
      :visible.sync="reverseRefundVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form ref="reverseRefundFormRef" :model="reverseRefundForm" label-width="110px">
        <el-form-item label="订单号">
          <el-input :value="(reverseRefundOrder && reverseRefundOrder.orderNo) || '-'" disabled />
        </el-form-item>
        <el-form-item label="支付金额(元)">
          <el-input :value="formatMoney(reverseRefundOrder && reverseRefundOrder.totalAmount)" disabled />
        </el-form-item>
        <el-form-item label="退款金额(元)">
          <el-input v-model.trim="reverseRefundForm.refundAmount" placeholder="不填默认全额退款" />
        </el-form-item>
        <el-form-item label="退款原因">
          <el-input
            v-model.trim="reverseRefundForm.reason"
            type="textarea"
            :rows="3"
            maxlength="100"
            show-word-limit
            placeholder="选填"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reverseRefundVisible = false">取消</el-button>
        <el-button type="primary" :loading="reverseRefundSubmitLoading" @click="submitReverseRefund">确认退款</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="汇付已分账退款（创建退款对象）"
      :visible.sync="divRefundVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form ref="divRefundFormRef" :model="divRefundForm" label-width="110px">
        <el-form-item label="订单号">
          <el-input :value="(divRefundOrder && divRefundOrder.orderNo) || '-'" disabled />
        </el-form-item>
        <el-form-item label="支付金额(元)">
          <el-input :value="formatMoney(divRefundOrder && divRefundOrder.totalAmount)" disabled />
        </el-form-item>
        <el-form-item label="退款金额(元)">
          <el-input v-model.trim="divRefundForm.refundAmount" placeholder="不填默认全额退款" />
        </el-form-item>
        <el-form-item label="退款原因">
          <el-input
            v-model.trim="divRefundForm.reason"
            type="textarea"
            :rows="3"
            maxlength="100"
            show-word-limit
            placeholder="选填"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="divRefundVisible = false">取消</el-button>
        <el-button type="primary" :loading="divRefundSubmitLoading" @click="submitDivRefund">确认退款</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { returnTime, isJSON, decodeUnicodeEscapes } from "@/util/utils";
import expressInfo from "@/util/expressInfo";

export default {
  data() {
    return {
      loading: false,
      companyData: expressInfo.arr || [],

      activeStatusTab: "all",
      statusTabs: [
        { label: "全部", name: "all", value: null },
        { label: "待支付", name: "0", value: 0 },
        { label: "待发货", name: "1", value: 1 },
        { label: "待收货", name: "2", value: 2 },
        { label: "待评价", name: "3", value: 3 },
        { label: "已完成", name: "4", value: 4 },
        { label: "已退款", name: "5", value: 5 },
        { label: "已取消", name: "6", value: 6 },
        { label: "退款中", name: "7", value: 7 },
      ],
      statusOptions: [
        { label: "全部", value: null },
        { label: "待支付", value: 0 },
        { label: "待发货", value: 1 },
        { label: "待收货", value: 2 },
        { label: "待评价", value: 3 },
        { label: "已完成", value: 4 },
        { label: "已退款", value: 5 },
        { label: "已取消", value: 6 },
        { label: "退款中", value: 7 },
      ],

      query: {
        status: null,
        orderNo: "",
        goofishOrderNo: "",
        buyerNickName: "",
        sellerNickName: "",
        consignorKeyword: "",
        productNo: "",
        importCode: "",
      },

      tableData: [],
      pageSize: 50,
      currentPage: 1,
      tableTotal: 0,

      detailVisible: false,
      detail: null,

      editVisible: false,
      editLoading: false,
      editSubmitLoading: false,
      editForm: null,
      reverseRefundVisible: false,
      reverseRefundSubmitLoading: false,
      reverseRefundOrder: null,
      reverseRefundForm: {
        refundAmount: "",
        reason: "",
      },
      divRefundVisible: false,
      divRefundSubmitLoading: false,
      divRefundOrder: null,
      divRefundForm: {
        refundAmount: "",
        reason: "",
      },
      supplementAddrVisible: false,
      supplementAddrSubmitLoading: false,
      supplementAddrForm: {
        buyerName: "",
        buyerPhone: "",
        areaStr: "",
        detail: "",
      },
      editLogisticsVisible: false,
      editLogisticsSubmitLoading: false,
      editLogisticsForm: {
        logisticsCompany: "",
        logisticsNo: "",
      },
    };
  },

  computed: {
    /** 普通闲置订单：0；官方寄售订单：1 */
    listProductType() {
      return this.$route.path === "/secondhandOfficialOrder" ? 1 : 0;
    },
    historyArr() {
      const sub = this.listProductType === 1 ? "官方寄售订单" : "普通闲置订单";
      return ["订单管理", sub];
    },
    isOfficialConsignList() {
      return this.listProductType === 1;
    },
    detailProduct() {
      return this.detail && this.detail.product ? this.detail.product : null;
    },
    /** 详情弹窗：优先商品全量图，兜底订单主图 */
    detailProductImageUrls() {
      if (!this.detail) return [];
      const p = this.detail.product || {};
      let urls = [];
      if (Array.isArray(p.imageList) && p.imageList.length) {
        urls = p.imageList.filter(Boolean);
      } else {
        urls = this.imageList(p.images);
      }
      if (!urls.length && this.detail.productImage) {
        urls = [this.detail.productImage];
      }
      return urls
        .map((u) => {
          const raw = String(u || "").trim();
          if (!raw) return "";
          return this.$assetUrl ? this.$assetUrl(raw) : raw;
        })
        .filter(Boolean);
    },
  },

  mounted() {
    this.syncTabFromStatus();
    this.fetchList(1);
  },

  watch: {
    "query.status": function () {
      this.syncTabFromStatus();
    },
    "$route.path"() {
      this.currentPage = 1;
      this.query.productNo = "";
      this.query.importCode = "";
      this.query.consignorKeyword = "";
      this.fetchList(1);
    },
  },

  methods: {
    /** 解析商品 images：JSON 数组或逗号分隔 */
    imageList(imagesStr) {
      if (!imagesStr) return [];
      try {
        if (isJSON(imagesStr)) {
          const arr = JSON.parse(imagesStr);
          return Array.isArray(arr) ? arr.filter(Boolean) : [];
        }
      } catch (e) {}
      return String(imagesStr)
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    },

    displayText(val) {
      if (val == null || val === "") return "";
      return decodeUnicodeEscapes(String(val).trim()) || "";
    },

    displayConsignorNick(row) {
      if (!row) return "";
      const p = row.product;
      const fromProduct = p && p.consignorNickName ? this.displayText(p.consignorNickName) : "";
      if (fromProduct) return fromProduct;
      return this.displayText(row.consignorNickName);
    },

    resolveProductNo(row) {
      if (!row) return "";
      const direct = String(row.productNo || "").trim();
      if (direct) return direct;
      const p = row.product;
      const fromProduct = p && p.productNo != null ? String(p.productNo).trim() : "";
      return fromProduct || "";
    },

    isGoofishChannel(row) {
      if (!row) return false;
      const ch = String(row.saleChannel || "").toUpperCase();
      if (ch === "GOOFISH" || ch === "GOOFISH_AUCTION") return true;
      const remark = String(row.remark || "");
      return remark.indexOf("GOOFISH:") === 0;
    },

    resolveGoofishOrderNo(row) {
      if (!row) return "";
      const direct = String(row.externalOrderNo || "").trim();
      if (direct) return direct;
      const remark = String(row.remark || "").trim();
      if (remark.indexOf("GOOFISH:") === 0) {
        return remark.slice("GOOFISH:".length).trim();
      }
      return "";
    },

    resolveImportCode(row) {
      if (!row) return "";
      const direct = String(row.importCode || "").trim();
      if (direct) return direct;
      const p = row.product;
      if (p) {
        const fromProduct = String(p.importCode || "").trim();
        if (fromProduct) return fromProduct;
        const raw = p.attrJson;
        if (raw) {
          try {
            const obj = isJSON(raw) ? JSON.parse(raw) : null;
            const code = obj && (obj.importCode || obj.import_code);
            if (code != null && String(code).trim()) return String(code).trim();
          } catch (e) {
            return "";
          }
        }
      }
      return "";
    },

    statusLabel(v, row) {
      // 保持闲置订单 status 枚举口径（0-7）；安心购流程细分看 inspectionFlowStatus
      const x = Number(v);
      const useInspection = Number((row && row.useInspection) || 0);
      const fs = Number((row && row.inspectionFlowStatus) || 0);
      // 安心购：卖家发货到平台阶段（1-4），即便 status=2 也视为“待发货至买家”
      if (useInspection === 1 && x === 2 && fs > 0 && fs < 5) return "待发货";
      // 安心购内部态：按“待发货”展示
      if (x === 8) return "待发货";
      if (x === 7) {
        if (this.isOfficialConsignList && row && Number(row.isPay) === 1) {
          return "已售出 · 退款中";
        }
        return "退款中";
      }
      const m = {
        0: "待支付",
        1: "待发货",
        2: "待收货",
        3: "待评价",
        4: "已完成",
        5: "已退款",
        6: "已取消",
      };
      return m[x] != null ? m[x] : String(v == null ? "-" : v);
    },

    systemCloseTypeLabel(type) {
      const t = String(type || "").trim();
      const m = {
        PAY_TIMEOUT: "超时未支付关单",
        PRODUCT_SOLD_CANCEL: "他人成交关单",
        CONCURRENT_PAY_REFUND: "并发支付原路退款",
        PAY_EXPIRED_REFUND: "超时支付原路退款",
        PRODUCT_NOT_FOUND_REFUND: "商品异常原路退款",
      };
      return m[t] || t || "-";
    },

    statusColor(v) {
      const x = Number(v);
      if (x === 7) return "#e6a23c";
      if (x === 0) return "#e6a23c";
      if (x === 4) return "#67c23a";
      if (x === 5 || x === 6) return "#909399";
      return "#333";
    },

    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },

    formatMoney(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      return Number.isNaN(n) ? String(v) : n.toFixed(2);
    },

    statusTagType(v) {
      const x = Number(v);
      if (x === 0 || x === 7) return "warning";
      if (x === 4) return "success";
      if (x === 5 || x === 6) return "info";
      return "";
    },

    copyText(text) {
      const t = text == null ? "" : String(text);
      if (!t) return;
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(t)
          .then(() => this.$message.success("已复制"))
          .catch(() => this.fallbackCopyText(t));
        return;
      }
      this.fallbackCopyText(t);
    },

    fallbackCopyText(t) {
      try {
        const el = document.createElement("textarea");
        el.value = t;
        el.setAttribute("readonly", "readonly");
        el.style.position = "fixed";
        el.style.left = "-9999px";
        el.style.top = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        this.$message.success("已复制");
      } catch (e) {
        this.$message.warning("复制失败，请手动复制");
      }
    },

    safeJsonParse(str) {
      if (!str) return null;
      try {
        return JSON.parse(String(str));
      } catch (e) {
        return null;
      }
    },

    normalizeAddressSnapshot(o) {
      if (!o || typeof o !== "object") return { name: "", phone: "", region: "", detail: "", full: "" };
      const pick = (keys) => {
        for (const k of keys) {
          const v = o[k];
          if (v != null && String(v).trim()) return String(v).trim();
        }
        return "";
      };
      const name = this.displayText(pick(["name", "userName", "receiverName", "consignee", "buyerName", "sellerName"]));
      const phone = pick(["phone", "mobile", "tel", "receiverPhone", "consigneePhone", "buyerPhone", "sellerPhone"]);
      const province = this.displayText(pick(["province", "provinceName"]));
      const city = this.displayText(pick(["city", "cityName"]));
      let district = "";
      if (Array.isArray(o.area)) {
        district = this.displayText(o.area.map((x) => String(x || "").trim()).filter(Boolean).join(""));
      }
      if (!district) {
        district = this.displayText(pick(["area", "district", "districtName", "county", "countyName"]));
      }
      // street/town 与 detail 拼接（去重）；勿用 pick 把 street 当 detail 兜底，否则有 detail 时会丢掉街道
      const street = pick(["street", "town"]);
      let detail = this.displayText(pick(["detail", "detailAddress", "addressDetail", "addr"]));
      if (street && (!detail || detail.indexOf(street) < 0)) {
        detail = detail ? street + detail : street;
      }
      detail = this.displayText(detail);
      const region = [province, city, district].filter(Boolean).join(" ");
      const full = [region, detail].filter(Boolean).join(" ");
      return { name, phone, province, city, district, detail, region, full };
    },

    buyerAddrSnap(d) {
      const o = this.safeJsonParse(d && d.buyerAddressJson);
      return this.normalizeAddressSnapshot(o);
    },

    sellerAddrSnap(d) {
      const o = this.safeJsonParse(d && d.sellerAddressJson);
      return this.normalizeAddressSnapshot(o);
    },

    buyerAddrDetailLine(d) {
      const snap = this.buyerAddrSnap(d);
      if (snap.detail) return snap.detail;
      const raw = d && d.buyerAddress ? this.displayText(d.buyerAddress) : "";
      if (raw && snap.region && raw.indexOf(snap.region) === 0) {
        return raw.slice(snap.region.length).trim() || raw;
      }
      return raw || snap.full || "-";
    },

    canSupplementBuyerAddress(d) {
      if (!d || !d.id) return false;
      if (Number(d.deliveryType) === 2) return false;
      const st = Number(d.status);
      const paid = Number(d.isPay) === 1;
      if (st === 0) return true;
      if (st === 1 && paid) {
        const hasShip =
          !!(d.logisticsNo && String(d.logisticsNo).trim())
          || !!(d.logisticsCompany && String(d.logisticsCompany).trim())
          || !!d.shipTime;
        return !hasShip;
      }
      return false;
    },

    isBuyerAddressMissing(d) {
      if (!d || !d.id) return false;
      if (Number(d.deliveryType) === 2) return false;
      const snap = this.buyerAddrSnap(d);
      const hasName = !!(snap.name || this.displayText(d.buyerName));
      const hasPhone = !!(snap.phone || d.buyerPhone);
      const detailLine = this.buyerAddrDetailLine(d);
      const hasAddr = !!(snap.region || (detailLine && detailLine !== "-"));
      return !(hasName && hasPhone && hasAddr);
    },

    openSupplementBuyerAddressFromRow(row) {
      if (!row || !row.id) return;
      this.detailFn(row);
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.detail && this.detail.id === row.id && this.canSupplementBuyerAddress(this.detail)) {
            this.openSupplementBuyerAddressDialog();
          }
        }, 400);
      });
    },

    openSupplementBuyerAddressDialog() {
      if (!this.detail || !this.detail.id) return;
      const snap = this.buyerAddrSnap(this.detail);
      this.supplementAddrForm = {
        buyerName: snap.name || this.displayText(this.detail.buyerName) || "",
        buyerPhone: snap.phone || this.detail.buyerPhone || "",
        areaStr: snap.region || "",
        detail: snap.detail || this.buyerAddrDetailLine(this.detail),
      };
      if (this.supplementAddrForm.detail === "-") {
        this.supplementAddrForm.detail = "";
      }
      this.supplementAddrSubmitLoading = false;
      this.supplementAddrVisible = true;
    },

    resetSupplementAddrForm() {
      this.supplementAddrForm = {
        buyerName: "",
        buyerPhone: "",
        areaStr: "",
        detail: "",
      };
      this.supplementAddrSubmitLoading = false;
    },

    submitSupplementBuyerAddress() {
      if (!this.detail || !this.detail.id) return;
      const f = this.supplementAddrForm || {};
      if (!String(f.buyerName || "").trim()) {
        this.$message.warning("请填写收货人");
        return;
      }
      if (!String(f.buyerPhone || "").trim()) {
        this.$message.warning("请填写联系电话");
        return;
      }
      if (!String(f.areaStr || "").trim() && !String(f.detail || "").trim()) {
        this.$message.warning("请填写省市区或详细地址");
        return;
      }
      this.supplementAddrSubmitLoading = true;
      this.$https(
        this.$api.api.supplementSecondhandBuyerAddress,
        {
          orderId: this.detail.id,
          buyerName: String(f.buyerName).trim(),
          buyerPhone: String(f.buyerPhone).trim(),
          areaStr: String(f.areaStr || "").trim(),
          detail: String(f.detail || "").trim(),
        },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.$message.success("收货地址已保存");
            this.supplementAddrVisible = false;
            this.detailFn(this.detail);
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "保存失败");
          }
        })
        .finally(() => {
          this.supplementAddrSubmitLoading = false;
        });
    },

    sellerAddrDetailLine(d) {
      const snap = this.sellerAddrSnap(d);
      if (snap.detail) return snap.detail;
      const raw = d && d.sellerAddress ? this.displayText(d.sellerAddress) : "";
      if (raw && snap.region && raw.indexOf(snap.region) === 0) {
        return raw.slice(snap.region.length).trim() || raw;
      }
      return raw || snap.full || "-";
    },

    syncTabFromStatus() {
      if (this.query.status == null) {
        this.activeStatusTab = "all";
        return;
      }
      const s = String(this.query.status);
      const hit = (this.statusTabs || []).find((t) => t.name === s);
      this.activeStatusTab = hit ? hit.name : "all";
    },

    handleStatusTabClick() {
      const hit = (this.statusTabs || []).find((t) => t.name === this.activeStatusTab);
      this.query.status = hit ? hit.value : null;
      this.currentPage = 1;
      this.fetchList(1);
    },

    resetFn() {
      this.query = {
        status: null,
        orderNo: "",
        goofishOrderNo: "",
        buyerNickName: "",
        sellerNickName: "",
        consignorKeyword: "",
        productNo: "",
        importCode: "",
      };
      this.currentPage = 1;
      this.fetchList(1);
    },

    searchFn() {
      this.currentPage = 1;
      this.fetchList(1);
    },

    changePage(p) {
      this.fetchList(p);
    },

    handlePageSizeChange() {
      this.fetchList(1);
    },

    fetchList(page) {
      this.loading = true;
      const obj = {
        page: page || 1,
        size: this.pageSize,
      };
      // 排除安心购订单；普通/官方寄售按商品 product_type 拆分
      obj.useInspection = 0;
      obj.filterProductType = this.listProductType;
      if (this.query.status != null) obj.status = this.query.status;
      const on = String(this.query.orderNo || "").trim();
      if (on) obj.orderNo = on;
      if (this.isOfficialConsignList) {
        const gon = String(this.query.goofishOrderNo || "").trim();
        if (gon) obj.externalOrderNo = gon;
      }
      const bn = String(this.query.buyerNickName || "").trim();
      if (bn) obj.buyerNickName = bn;
      if (this.isOfficialConsignList) {
        const ck = String(this.query.consignorKeyword || "").trim();
        if (ck) obj.consignorKeyword = ck;
        const productNo = String(this.query.productNo || "").trim();
        if (productNo) obj.filterProductNo = productNo;
        const importCode = String(this.query.importCode || "").trim();
        if (importCode) obj.filterImportCode = importCode;
      } else {
        const sn = String(this.query.sellerNickName || "").trim();
        if (sn) obj.sellerNickName = sn;
      }

      this.$https(this.$api.api.selSecondhandOrder, obj, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.tableData = res.data.data || [];
            this.tableTotal = res.data.size || 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error((res.data && res.data.msg) || "查询失败");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    detailFn(row) {
      if (!row || !row.id) return;
      this.detailVisible = true;
      this.detail = null;
      this.$https(this.$api.api.getSecondhandOrderById, { id: row.id }, "GET").then((res) => {
        if (res.data && res.data.code == 200) {
          this.detail = res.data.data;
        } else {
          this.$message.error((res.data && res.data.msg) || "查询详情失败");
        }
      });
    },

    logisticsCompanyLabel(raw) {
      const s = raw == null ? "" : String(raw).trim();
      if (!s) return "";
      const hit = (this.companyData || []).find((i) => i && (i.code === s || i.title === s));
      return hit ? hit.title : s;
    },

    normalizeLogisticsCompanyForSelect(raw) {
      const s = raw == null ? "" : String(raw).trim();
      if (!s) return "";
      const arr = this.companyData || [];
      if (arr.some((i) => i && i.code === s)) return s;
      const byTitle = arr.find((i) => i && i.title === s);
      if (byTitle) return byTitle.code;
      return s;
    },

    openEditLogisticsDialog() {
      if (!this.detail || !this.detail.id) return;
      this.editLogisticsForm = {
        logisticsCompany: this.normalizeLogisticsCompanyForSelect(this.detail.logisticsCompany),
        logisticsNo: this.detail.logisticsNo || "",
      };
      this.editLogisticsSubmitLoading = false;
      this.editLogisticsVisible = true;
    },

    resetEditLogisticsForm() {
      this.editLogisticsForm = {
        logisticsCompany: "",
        logisticsNo: "",
      };
      this.editLogisticsSubmitLoading = false;
    },

    submitEditLogistics() {
      if (!this.detail || !this.detail.id) return;
      const company = (this.editLogisticsForm.logisticsCompany || "").trim();
      if (!company) {
        this.$message.error("请选择或填写物流公司");
        return;
      }
      const no = (this.editLogisticsForm.logisticsNo || "").trim();
      if (!no) {
        this.$message.error("请填写物流单号");
        return;
      }
      this.editLogisticsSubmitLoading = true;
      this.$https(
        this.$api.api.updateSecondhandOrder,
        {
          id: this.detail.id,
          logisticsCompany: company,
          logisticsNo: no,
        },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("物流信息已保存");
            this.editLogisticsVisible = false;
            this.fetchList(this.currentPage);
            this.$https(this.$api.api.getSecondhandOrderById, { id: this.detail.id }, "GET").then((r2) => {
              if (r2.data && r2.data.code == 200) {
                this.detail = r2.data.data;
              }
            });
          } else {
            this.$message.error((res.data && res.data.msg) || "保存失败");
          }
        })
        .finally(() => {
          this.editLogisticsSubmitLoading = false;
        });
    },

    editFn(row) {
      if (!row || !row.id) return;
      this.editVisible = true;
      this.editLoading = true;
      this.editSubmitLoading = false;
      this.editForm = null;

      this.$https(this.$api.api.getSecondhandOrderById, { id: row.id }, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            const d = res.data.data || {};
            this.editForm = {
              id: d.id,
              orderNo: d.orderNo,
              status: d.status,
              logisticsCompany: d.logisticsCompany,
              logisticsNo: d.logisticsNo,
              shipTime: d.shipTime || null,
              remark: d.remark,
            };
          } else {
            this.$message.error((res.data && res.data.msg) || "加载订单失败");
            this.editVisible = false;
          }
        })
        .finally(() => {
          this.editLoading = false;
        });
    },

    submitEditFn() {
      if (!this.editForm || !this.editForm.id) return;
      this.editSubmitLoading = true;
      this.$https(this.$api.api.updateSecondhandOrder, this.editForm, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("保存成功");
            this.editVisible = false;
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "保存失败");
          }
        })
        .finally(() => {
          this.editSubmitLoading = false;
        });
    },
    canReverseRefund(row) {
      if (!row) return false;
      const isPay = Number(row.isPay || 0) === 1;
      const status = Number(row.status);
      // 仅在已支付且未完成/未退款/未取消时展示入口，具体未分账校验以后端为准
      return isPay && (status === 1 || status === 2);
    },
    openReverseRefundDialog(row) {
      if (!row || !row.id) return;
      this.reverseRefundOrder = row;
      this.reverseRefundForm = {
        refundAmount: "",
        reason: "",
      };
      this.reverseRefundSubmitLoading = false;
      this.reverseRefundVisible = true;
    },
    canDivRefund(row) {
      if (!row) return false;
      const isPay = Number(row.isPay || 0) === 1;
      const status = Number(row.status);
      // 买家确认收货后（待评价/已完成）才可能已分账；是否已提现以后端校验为准
      return isPay && (status === 3 || status === 4);
    },
    openDivRefundDialog(row) {
      if (!row || !row.id) return;
      this.divRefundOrder = row;
      this.divRefundForm = {
        refundAmount: "",
        reason: "",
      };
      this.divRefundSubmitLoading = false;
      this.divRefundVisible = true;
    },
    submitReverseRefund() {
      if (!this.reverseRefundOrder || !this.reverseRefundOrder.id) return;
      const rawAmt = String((this.reverseRefundForm && this.reverseRefundForm.refundAmount) || "").trim();
      let refundAmount = null;
      if (rawAmt) {
        const n = Number(rawAmt);
        if (Number.isNaN(n) || n <= 0) {
          this.$message.warning("退款金额需大于0");
          return;
        }
        refundAmount = Number(n.toFixed(2));
      }
      const payload = {
        orderId: this.reverseRefundOrder.id,
        reason: String((this.reverseRefundForm && this.reverseRefundForm.reason) || "").trim(),
      };
      if (refundAmount != null) payload.refundAmount = refundAmount;
      this.reverseRefundSubmitLoading = true;
      this.$https(this.$api.api.huifuReverseRefundSecondhandOrder, payload, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("退款成功");
            this.reverseRefundVisible = false;
            this.fetchList(this.currentPage);
            if (this.detailVisible && this.detail && this.detail.id === this.reverseRefundOrder.id) {
              this.detailFn(this.reverseRefundOrder);
            }
          } else {
            this.$message.error((res.data && res.data.msg) || "退款失败");
          }
        })
        .finally(() => {
          this.reverseRefundSubmitLoading = false;
        });
    },
    submitDivRefund() {
      if (!this.divRefundOrder || !this.divRefundOrder.id) return;
      const rawAmt = String((this.divRefundForm && this.divRefundForm.refundAmount) || "").trim();
      let refundAmount = null;
      if (rawAmt) {
        const n = Number(rawAmt);
        if (Number.isNaN(n) || n <= 0) {
          this.$message.warning("退款金额需大于0");
          return;
        }
        refundAmount = Number(n.toFixed(2));
      }
      const payload = {
        orderId: this.divRefundOrder.id,
        reason: String((this.divRefundForm && this.divRefundForm.reason) || "").trim(),
      };
      if (refundAmount != null) payload.refundAmount = refundAmount;
      this.divRefundSubmitLoading = true;
      this.$https(this.$api.api.huifuDivRefundSecondhandOrder, payload, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("退款成功");
            this.divRefundVisible = false;
            this.fetchList(this.currentPage);
            if (this.detailVisible && this.detail && this.detail.id === this.divRefundOrder.id) {
              this.detailFn(this.divRefundOrder);
            }
          } else {
            this.$message.error((res.data && res.data.msg) || "退款失败");
          }
        })
        .finally(() => {
          this.divRefundSubmitLoading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;

  .secondhand-order-tabs {
    margin-top: 12px;
    ::v-deep .el-tabs__content {
      display: none;
    }
    ::v-deep .el-tabs__header {
      margin-bottom: 0;
    }
  }

  .topBox {
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }

  .topLeft {
    align-items: center;
  }

  .order-op-actions {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    width: 100%;
    box-sizing: border-box;
  }

  .order-op-actions ::v-deep .el-button {
    margin: 0;
    padding-left: 8px;
    padding-right: 8px;
  }

  ::v-deep .order-op-cell .cell {
    overflow: visible;
    white-space: normal;
    line-height: normal;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .detail-dialog-body {
    max-height: min(560px, calc(100vh - 200px));
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: 4px;
    margin-right: -4px;
  }

  .detail-section {
    margin-bottom: 20px;
    &--last {
      margin-bottom: 0;
    }
  }

  .detail-section__title {
    margin: 0 0 10px;
    padding: 0;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
    border-left: 3px solid #409eff;
  }

  .detail-section__hint {
    margin: -4px 0 10px;
    padding: 0;
    font-size: 12px;
    line-height: 1.5;
    color: #909399;
  }

  .detail-section__title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;

    .detail-section__title {
      margin-bottom: 0;
    }
  }

  .detail-section--product {
    margin-bottom: 16px;
  }

  .detail-section__title--images {
    margin-top: 12px;
    margin-bottom: 8px;
  }

  .detail-dialog-images {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .detail-dialog-img {
    width: 88px;
    height: 88px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    display: block;
    cursor: pointer;
  }

  .detail-dialog-images-empty {
    color: #909399;
    font-size: 13px;
  }

  .detail-product-card {
    display: flex;
    align-items: stretch;
    gap: 16px;
    padding: 14px 16px;
    background: #fafafa;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    box-sizing: border-box;
  }

  .detail-product-card__meta {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
  }

  .detail-product-card__title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    line-height: 1.5;
    word-break: break-word;
  }

  .detail-field-box {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0;
    width: 100%;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    box-sizing: border-box;
    &--cols2 {
      grid-template-columns: repeat(2, 1fr);
    }
    &--compact {
      .detail-field-value {
        flex: none;
        min-height: auto;
        align-items: flex-start;
      }
    }
  }

  .detail-field-cell {
    display: flex;
    flex-direction: column;
    min-width: 0;
    background: #fff;
    border-right: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
    &--full {
      grid-column: 1 / -1;
      width: 100%;
    }
  }

  .detail-field-label {
    flex-shrink: 0;
    padding: 8px 10px;
    background: #f5f7fa;
    color: #606266;
    font-size: 12px;
    line-height: 1.4;
    text-align: left;
    border-bottom: 1px solid #ebeef5;
    box-sizing: border-box;
  }

  .detail-field-value {
    flex: 1;
    min-width: 0;
    width: 100%;
    min-height: 36px;
    padding: 8px 10px;
    font-size: 13px;
    color: #303133;
    line-height: 1.5;
    word-break: break-all;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .detail-field-value--multiline {
    align-items: flex-start;
    white-space: pre-wrap;
  }

  .detail-field-value--party {
    gap: 10px;
  }

  .detail-party-avatar {
    flex-shrink: 0;
  }

  .detail-field-mono {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 12px;
    line-height: 1.4;
    color: #303133;
    word-break: break-all;
  }

  .detail-text-success {
    color: #67c23a;
  }

  .detail-text-danger {
    color: #f56c6c;
  }

  .detail-copy-btn {
    margin-left: 8px;
    padding: 0;
  }

  .detail-money {
    font-weight: 600;
    font-variant-numeric: tabular-nums;
  }

  .detail-money--primary {
    font-size: 16px;
    color: #f56c6c;
  }

  .detail-collapse {
    width: 100%;
  }

  .detail-json {
    margin: 0;
    padding: 10px 12px;
    background: #0b1020;
    color: #e5e7eb;
    border-radius: 6px;
    overflow: auto;
    max-height: 220px;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 12px;
    line-height: 1.5;
  }

  /* 表格网格线更清晰（含固定列区域，scoped 下用 v-deep） */
  ::v-deep .secondhand-order-table.el-table--border,
  ::v-deep .secondhand-order-table.el-table--group {
    border: 1px solid #c0c4cc !important;
  }

  ::v-deep .secondhand-order-table.el-table--border::after,
  ::v-deep .secondhand-order-table.el-table--group::after,
  ::v-deep .secondhand-order-table .el-table__fixed::before,
  ::v-deep .secondhand-order-table .el-table__fixed-right::before {
    background-color: #c0c4cc !important;
  }

  ::v-deep .secondhand-order-table th.el-table__cell,
  ::v-deep .secondhand-order-table td.el-table__cell {
    border-right: 1px solid #c0c4cc !important;
    border-bottom: 1px solid #c0c4cc !important;
  }

  ::v-deep .secondhand-order-table thead th.el-table__cell {
    background: #fafafa !important;
  }

  ::v-deep .secondhand-order-table .el-table__fixed-right {
    box-shadow: -1px 0 0 #c0c4cc !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/secondhandOrder/index.vue